import React from "react";
import "./metricsCard.css";
import { Tooltip } from "@mui/material";

const MetricsCard = ({ title, value, titleTooltip }) => {
  return (
    <Tooltip title={titleTooltip ?? ""} arrow placement="top">
      <div className="metrics-card">
        <section className="d-flex justify-content-between container-fluid">
          <h4 className="metrics-card-title ">{title}</h4>
        </section>
        <section className="d-flex  justify-content-between container-fluid gap-2">
          <p className="value">{value}</p>
        </section>
      </div>
    </Tooltip>
  );
};

export default MetricsCard;
